import "./Carousel.scss";

const Carousel = ({ componentToDisplay }) => {
  return <div className="carousel">{componentToDisplay}</div>;
};

export default Carousel;
